export class OknoInformacyjneUtils {

  /**
   * Funkcja oblicza pozycje x okna informacji o obiekcie
   * @param punktX
   */
  static obliczPozycjeOknaX(punktX: number, szerokoscOkna: number, szerokoscMapa: number): number {
    const przestrzenZPrawej = szerokoscMapa - punktX;
    let polozenieX = 0;
    if (punktX > przestrzenZPrawej) {
      if (punktX > szerokoscOkna + 50) {
        polozenieX = punktX - szerokoscOkna - 25;
      } else {
        polozenieX = 25;
      }
    } else {
      if (przestrzenZPrawej > szerokoscOkna + 50) {
        polozenieX = punktX + 25;
      } else {
        polozenieX = szerokoscMapa - szerokoscOkna - 25
      }
    }
    return polozenieX;
  }

  /**
   * Funkcja oblicza pozycje y okna informacji o obiekcie
   * @param punktY
   */
  static obliczPozycjeOknaY(punktY: number, wysokoscOkna: number, wysokoscMapa: number): number {
    const przestrzenOdDolu = wysokoscMapa - punktY;
    let polozenieY = 0;
    if (punktY > przestrzenOdDolu + 50) {
      if (punktY > wysokoscOkna) {
        polozenieY = punktY - wysokoscOkna + 25;
      } else {
        polozenieY = 25;
      }
    } else {
      if (przestrzenOdDolu > wysokoscOkna + 50) {
        polozenieY = punktY + 25;
      } else {
        polozenieY = 25
      }
    }
    return polozenieY;
  }
}
